import { ROUTES } from "../constants/api";
import {
  HandleNewResponse,
  HandleNewErrorResponse,
} from "./handlers";
import {
  get,
  post,
  put
} from "./api";

import { UpdateAllocationType } from "../types/api/allocations";

/**
 * Handles calls to the User API
 */
class AllocationsApi {
  /**
     * Gets user's payment and disbursement history
     * @constructor
     */
  static async GetAllocations() {
    let url = ROUTES.ALLOCATIONS.INDEX;

    try {
      let response = await get(url);
      return HandleNewResponse(response);
    } catch (err) {
      return HandleNewErrorResponse(err);
    }
  }

  /**
   * Gets user's free transfer allocations
   * @constructor
   */
  static async GetFreeTransfers(allocationIds: string[]) {
    let url = ROUTES.ALLOCATIONS.GET_FREE_TRANSFERS;

    try {
      let response = await post(url, { allocationIds });
      return HandleNewResponse(response);
    } catch (err) {
      return HandleNewErrorResponse(err);
    }
  }

  /**
     * Updates user's allocations
     * @constructor
     */
  static async UpdateAllocations(requestBody: { allocations: UpdateAllocationType[] }) {
    let url = ROUTES.ALLOCATIONS.UPDATE_ALLOCATIONS;

    try {
      let response = await put(url, requestBody);
      return HandleNewResponse(response);
    } catch (err) {
      return HandleNewErrorResponse(err);
    }
  }
}

export default AllocationsApi;
